"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggleMedalliaModal = exports.MEDALLIA_MODAL_ID = void 0;
const react_1 = require("react");
const elementStyleModifier_1 = require("../../utils/helpers/elementStyleModifier/elementStyleModifier");
exports.MEDALLIA_MODAL_ID = ['kampyleInvite', 'KampyleAnimationContainer'];
/**
 * Este hook alterna a visibilidade do modal Medallia com base no valor do parâmetro 'hide'.
 *
 * @param {boolean} hide - Indica se o modal Medallia deve ser oculto ou não
 * @return {void}
 */
const useToggleMedalliaModal = (hide) => {
    (0, react_1.useEffect)(() => {
        if (hide) {
            (0, elementStyleModifier_1.elementStyleModifier)({
                elementId: exports.MEDALLIA_MODAL_ID,
                styleOverride: { display: 'none' },
                watchElement: true,
            });
        }
        else {
            (0, elementStyleModifier_1.elementStyleModifier)({
                elementId: exports.MEDALLIA_MODAL_ID,
                styleOverride: { display: 'block' },
                watchElement: false,
            });
        }
    }, [hide]);
};
exports.useToggleMedalliaModal = useToggleMedalliaModal;
